import { Box, Skeleton } from '@mui/material';

const SalesforceTaskCreateFormSkeleton = () => (
	<Box
		sx={{
			flex: 1,
			padding: '16px 18px',
		}}
	>
		<Skeleton variant='text' width={160} height={20} sx={{ mb: '12px' }} />

		<Skeleton
			variant='rounded'
			height={52}
			sx={{
				mb: '16px',
				borderRadius: '6px',
			}}
		/>

		<Skeleton variant='text' width={80} height={18} sx={{ mb: '6px' }} />

		<Box
			sx={{
				backgroundColor: 'background.subtle',
				borderRadius: '8px',
				padding: '8px 10px',
			}}
		>
			{Array.from({ length: 6 }).map((_, index) => (
				<Box
					key={index}
					sx={{
						display: 'grid',
						gridTemplateColumns: '120px minmax(0, 1fr)',
						gap: '12px',
						alignItems: 'center',
						py: '7px',
					}}
				>
					<Skeleton variant='text' width={70} height={18} />

					<Skeleton
						variant='rounded'
						height={40}
						sx={{ borderRadius: '6px' }}
					/>
				</Box>
			))}

			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: '120px minmax(0, 1fr)',
					gap: '12px',
					alignItems: 'flex-start',
					py: '7px',
				}}
			>
				<Skeleton variant='text' width={70} height={18} />

				<Skeleton variant='rounded' height={96} sx={{ borderRadius: '6px' }} />
			</Box>
		</Box>
	</Box>
);

export default SalesforceTaskCreateFormSkeleton;
